<div
    *ngIf="syncingItems > 0"
    class="progress" style="position: fixed; width: 100%; top: 0; height: 0.25rem; z-index: 1;">
  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
</div>
